import {
	reOrgConstants
}from "./constants"
import actions from '../../../actions'

const initialState = {
	isSending : false,
	minOrg    : [],
	paged     : {},
	changed   : null,
	info      : {},
	orgStores : []
}

export default function (state = initialState, action){
	switch (action.type){
		case (reOrgConstants.GetMinOrgByNameOrUNP.REQUEST):
		case (reOrgConstants.Create.REQUEST):
		case (reOrgConstants.Update.REQUEST):
		case (reOrgConstants.GetPaged.REQUEST):
		case (reOrgConstants.UpdateReOrgInfo.REQUEST):
		case (reOrgConstants.Delete.REQUEST):
		case (reOrgConstants.GetReOrgInfo.REQUEST) :
			return {
				...state,
				isSending : true,
				changed   : null
			}
		case (reOrgConstants.GetMinOrgByNameOrUNP.FAILURE):
		case (reOrgConstants.Create.FAILURE):
		case (reOrgConstants.Update.FAILURE):
		case (reOrgConstants.UpdateReOrgInfo.FAILURE):
		case (reOrgConstants.Delete.FAILURE):
		case (reOrgConstants.GetReOrgInfo.FAILURE) :
		case (reOrgConstants.GetPaged.FAILURE):
			return {
				...state,
				error     : action.payload,
				isSending : false
			}
		case (reOrgConstants.GetPaged.SUCCESS):
			return {
				...state,
				isSending : false,
				paged     : action.payload.result
			}
		case (reOrgConstants.GetMinOrgByNameOrUNP.SUCCESS):
			return {
				...state,
				isSending : false,
				minOrg    : action.payload.result
			}
		case (reOrgConstants.GetReOrgInfo.SUCCESS):
			return {
				...state,
				isSending : false,
				info      : action.payload.result
			}

		case (reOrgConstants.Create.SUCCESS):
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.create : null
			}
		case (reOrgConstants.Update.SUCCESS):
		case (reOrgConstants.UpdateReOrgInfo.SUCCESS):
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.update : null
			}
		case (reOrgConstants.Delete.SUCCESS):
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.delete : null
			}
		case (reOrgConstants.CLEAR):
			return {
				...state,
				isSending : false,
				paged     : {},
				changed   : null
			}
		default:
			return state
	}
}